<ng-container *ngIf="$success | async; else showForm">
  <div class="success">
    <h3 class="success__header">Thank You</h3>
    <p class="success__description">We will respond within 24 hours.</p>
    <p class="success__description">If you can’t wait you are welcome to call <a href="tel: {{ phoneNumber }}">{{ phoneNumber }}</a></p>
  </div>
</ng-container>
<ng-template #showForm>
  <p *ngIf="$error | async as err" class="error">{{ err }}</p>
  <form [formGroup]="reactiveForm" (ngSubmit)="onSubmit()">
    <div class="p-field p-fluid">
      <label for="fullname">Name</label>
      <input
        type="text"
        id="fullname"
        formControlName="fullName"
        class="p-inputtext p-component p-element"
      />
      <small
        *ngIf="
          reactiveForm.get('fullName')?.touched &&
          reactiveForm.get('fullName')?.invalid
        "
        for="fullname"
        class="p-error"
        >Name is required.
      </small>
    </div>
    <div class="p-field p-fluid">
      <label for="phone">
        <span>Phone (+country code)</span><span>OPTIONAL</span>
      </label>
      <input
        type="tel"
        id="phone"
        formControlName="phone"
        class="p-inputtext"
      />
    </div>
    <div class="p-field p-fluid">
      <label for="email">Email</label>
      <input
        type="email"
        id="email"
        formControlName="email"
        class="p-inputtext"
      />
      <small
        *ngIf="
          reactiveForm.get('email')?.touched &&
          reactiveForm.get('email')?.invalid
        "
        for="username"
        class="p-error">Email is required.
      </small>
    </div>
    <div class="p-field p-fluid">
      <label for="topic">
        <span>Topic</span><span>OPTIONAL</span>
      </label>
      <p-dropdown
        [options]="allBrands"
        formControlName="topic"
        [placeholder]="'Select'"
        id="topic">
      </p-dropdown>
    </div>
    <div class="p-field p-fluid">
      <label for="message">
        <span>Message</span><span>OPTIONAL</span>
      </label>
      <textarea
        style="height: 15vh"
        type="text"
        id="message"
        formControlName="message"
        class="p-inputtextarea p-inputtext">
      </textarea>
      <small
        *ngIf="
          reactiveForm.get('message')?.touched &&
          reactiveForm.get('message')?.invalid
        "
        for="message"
        class="p-error">Message is required.
      </small>
    </div>
    <div class="button">
      <button
        [disabled]="reactiveForm.invalid"
        type="submit"
        class="btn"
        [ngClass]="{ invalid: reactiveForm.invalid }">Submit
      </button>
    </div>
  </form>
</ng-template>
